var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0004,
    cy: 25.0001,
    r: 24.2806,
    fill: "#201160"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1404 24.0311H34.686L39.1404 19.5742H34.686",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2319 26.8156H26.8906L30.2319 23.4744H26.8906",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3451 19.0201H24.6626L31.3451 12.3376H24.6626",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5325 31.6848C24.4729 31.6846 20.7454 29.4418 18.8436 25.8552C16.9418 22.2686 17.1768 17.9248 19.4544 14.5642C14.1187 16.3724 10.7566 21.646 11.3691 27.2464C11.9816 32.8468 16.404 37.269 22.0044 37.8813C27.6048 38.4935 32.8783 35.1312 34.6863 29.7955C32.8715 31.0294 30.727 31.6878 28.5325 31.6848V31.6848Z",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/sleep.7dfc81fe8ee7c376b86c8c3c0a6815a5.svg";
export { ForwardRef as ReactComponent };